module.exports = __webpack_public_path__ + "static/media/Slide_4.5caf683b.png";